<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <h4>Εξαγωγή Πιστοποιητικών</h4>
        </CCardHeader>
        <CCardBody>
          <!-- Filters Section -->
          <CCard class="mb-4">
            <CCardHeader>
              <strong>Φίλτρα</strong>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Έκδοσης Από</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.date_from"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Έκδοσης Έως</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.date_to"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Λήξης Από</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.expiry_date_from"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Λήξης Έως</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.expiry_date_to"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Ενημέρωσης Από</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.update_date_from"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Ημ/νία Ενημέρωσης Έως</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.update_date_to"
                    />
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Κατάσταση</label>
                    <select class="form-control" v-model="filters.status_id">
                      <option value="">Όλες</option>
                      <option v-for="status in statuses" :key="status.id" :value="status.id">
                        {{ status.name }}
                      </option>
                    </select>
                  </div>
                </CCol>
                <CCol md="3">
                  <div class="form-group">
                    <label>Πελάτης</label>
                    <select class="form-control" v-model="filters.client_id">
                      <option value="">Όλοι</option>
                      <option v-for="client in clients" :key="client.id" :value="client.id">
                        {{ client.company }} ({{ client.afm }})
                      </option>
                    </select>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6">
                  <div class="form-group">
                    <label>Πρότυπο (ISO)</label>
                    <multiselect
                      v-model="selectedServices"
                      :options="groupedServices"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Επιλέξτε πρότυπα"
                      label="name"
                      track-by="id"
                      group-values="services"
                      group-label="group"
                      :group-select="true"
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CButton color="primary" @click="loadPreview" :disabled="loading">
                    <span v-if="loading">
                      <CSpinner size="sm" /> Φόρτωση...
                    </span>
                    <span v-else>Προεπισκόπηση</span>
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="clearFilters">
                    Καθαρισμός Φίλτρων
                  </CButton>
                  <CButton
                    color="success"
                    class="ml-2"
                    @click="exportToExcel"
                    :disabled="!hasData || loading"
                  >
                    Εξαγωγή σε Excel
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <!-- Summary -->
          <CAlert v-if="hasData" color="info" class="mb-4">
            <strong>Σύνοψη:</strong>
            {{ summary.total_entities }} πιστοποιημένοι φορείς,
            {{ summary.total_certifications }} πιστοποιητικά
          </CAlert>

          <!-- Preview Tabs -->
          <CTabs v-if="hasData" :active-tab="activeTab" @update:activeTab="activeTab = $event">
            <CTab title="Certified Entity">
              <CDataTable
                :items="data.certified_entities"
                :fields="certifiedEntityFields"
                :items-per-page="10"
                hover
                pagination
                table-filter
                sorter
                class="mt-3"
              />
            </CTab>
            <CTab title="Certification">
              <CDataTable
                :items="data.certifications"
                :fields="certificationFields"
                :items-per-page="10"
                hover
                pagination
                table-filter
                sorter
                class="mt-3"
              />
            </CTab>
            <CTab title="Certification Standard & Scheme">
              <CDataTable
                :items="data.standards"
                :fields="standardFields"
                :items-per-page="10"
                hover
                pagination
                table-filter
                sorter
                class="mt-3"
              />
            </CTab>
            <CTab title="Certification Sector">
              <CDataTable
                :items="data.sectors"
                :fields="sectorFields"
                :items-per-page="10"
                hover
                pagination
                table-filter
                sorter
                class="mt-3"
              />
            </CTab>
            <CTab title="Certification Sites">
              <CDataTable
                :items="data.sites"
                :fields="siteFields"
                :items-per-page="10"
                hover
                pagination
                table-filter
                sorter
                class="mt-3"
              />
            </CTab>
          </CTabs>

          <!-- No Data Message -->
          <CAlert v-if="loaded && !hasData" color="warning">
            Δεν βρέθηκαν πιστοποιητικά με τα επιλεγμένα φίλτρα.
          </CAlert>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'

// Field definitions for each table - matching Excel headers exactly
const certifiedEntityFields = [
  { key: 'certified_entity_unique_id', label: 'Certified Entity Unique ID', sorter: true },
  { key: 'certified_entity_name', label: 'Certified Entity Name', sorter: true },
  { key: 'certified_entity_trading_name', label: 'Certified Entity Trading Name', sorter: true },
  { key: 'certified_entity_english_name', label: 'Certified Entity English Name', sorter: true },
  { key: 'confidential_certified_entity', label: 'Confidential Certified Entity', sorter: true },
  { key: 'business_registered_street', label: 'Business Registered Street', sorter: true },
  { key: 'business_registered_city', label: 'Business Registered City', sorter: true },
  { key: 'business_registered_state', label: 'Business Registered State', sorter: true },
  { key: 'business_registered_zipcode', label: 'Business Registered Zipcode/Postcode', sorter: true },
  { key: 'business_registered_country', label: 'Business Registered Country/Economy', sorter: true },
  { key: 'business_registered_full_address', label: 'Business Registered Full Address', sorter: true },
  { key: 'certified_entity_website', label: 'Certified Entity Website', sorter: true },
  { key: 'tax_id', label: 'TAX ID', sorter: true },
  { key: 'vat', label: 'VAT', sorter: true },
  { key: 'company_id_number', label: 'Company ID Number', sorter: true },
  { key: 'business_registration_number', label: 'Business Registration Number', sorter: true },
  { key: 'duns_number', label: 'DUNS Number', sorter: true }
]

const certificationFields = [
  { key: 'certification_identity_number', label: 'Certification Identity Number', sorter: true },
  { key: 'certificate_number', label: 'Certificate Number', sorter: true },
  { key: 'certification_status', label: 'Certification Status', sorter: true },
  { key: 'certification_type', label: 'Certification Type', sorter: true },
  { key: 'certification_scope', label: 'Certification Scope', sorter: true },
  { key: 'flexible_scope', label: 'Flexible Scope', sorter: true },
  { key: 'certification_original_issue_date', label: 'Certification Original Issue Date', sorter: true },
  { key: 'certification_issue_date', label: 'Certification Issue Date', sorter: true },
  { key: 'certification_expiry_date', label: 'Certification Expiry Date', sorter: true },
  { key: 'certified_entity_unique_id', label: 'Certified Entity Unique ID', sorter: true },
  { key: 'main_site_street', label: 'Main Site Street', sorter: true },
  { key: 'main_site_city', label: 'Main Site City', sorter: true },
  { key: 'main_site_state', label: 'Main Site State', sorter: true },
  { key: 'main_site_zipcode', label: 'Main Site Zipcode/Postcode', sorter: true },
  { key: 'main_site_country', label: 'Main Site Country/Economy', sorter: true },
  { key: 'main_site_full_address', label: 'Main Site Full Address', sorter: true },
  { key: 'accreditation_body_name', label: 'Accreditation Body Name', sorter: true },
  { key: 'accreditation_body_acronym', label: 'Accreditation Body Acronym', sorter: true }
]

const standardFields = [
  { key: 'certification_identity_number', label: 'Certification Identity Number', sorter: true },
  { key: 'scheme_name', label: 'Scheme Name', sorter: true },
  { key: 'standard_name', label: 'Standard Name', sorter: true }
]

const sectorFields = [
  { key: 'certification_identity_number', label: 'Certification Identity Number', sorter: true },
  { key: 'sector_name', label: 'Sector Name', sorter: true },
  { key: 'sector_code', label: 'Sector Code', sorter: true }
]

const siteFields = [
  { key: 'certification_identity_number', label: 'Certification Identity Number', sorter: true },
  { key: 'certified_entity_unique_id', label: 'Certified Entity Unique ID', sorter: true },
  { key: 'site_type', label: 'Site Type', sorter: true },
  { key: 'site_street', label: 'Site Street', sorter: true },
  { key: 'site_city', label: 'Site City', sorter: true },
  { key: 'site_state', label: 'Site State', sorter: true },
  { key: 'site_zipcode', label: 'Site Zipcode/Postcode', sorter: true },
  { key: 'site_country', label: 'Site Country/Economy', sorter: true },
  { key: 'site_full_address', label: 'Site Full Address', sorter: true },
  { key: 'site_scope', label: 'Site Scope', sorter: true }
]

export default {
  name: 'ExportCertifications',
  components: {
    Multiselect
  },
  data() {
    return {
      loading: false,
      loaded: false,
      activeTab: 0,
      filters: {
        date_from: '',
        date_to: '',
        expiry_date_from: '',
        expiry_date_to: '',
        update_date_from: '',
        update_date_to: '',
        status_id: '',
        client_id: ''
      },
      statuses: [],
      services: [],
      clients: [],
      selectedServices: [],
      data: {
        certified_entities: [],
        certifications: [],
        standards: [],
        sectors: [],
        sites: []
      },
      summary: {
        total_entities: 0,
        total_certifications: 0
      },
      certifiedEntityFields,
      certificationFields,
      standardFields,
      sectorFields,
      siteFields
    }
  },
  computed: {
    hasData() {
      return this.data.certifications && this.data.certifications.length > 0
    },
    groupedServices() {
      const groups = {}
      this.services.forEach(service => {
        const groupName = service.group || 'Χωρίς ομάδα'
        if (!groups[groupName]) {
          groups[groupName] = []
        }
        groups[groupName].push(service)
      })
      return Object.keys(groups).map(group => ({
        group: group,
        services: groups[group]
      }))
    }
  },
  methods: {
    async loadFilterOptions() {
      try {
        const response = await axios.get('/api/certifications/export/filter-options', {
          params: { token: localStorage.getItem('api_token') }
        })
        this.statuses = response.data.statuses || []
        this.services = response.data.services || []
        this.clients = response.data.clients || []
      } catch (error) {
        console.error('Error loading filter options:', error)
      }
    },
    async loadPreview() {
      this.loading = true
      try {
        const params = {
          token: localStorage.getItem('api_token'),
          ...this.filters
        }
        // Handle service_ids from multiselect
        if (this.selectedServices && this.selectedServices.length > 0) {
          params.service_ids = this.selectedServices.map(s => s.id).join(',')
        }
        // Remove empty filters
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || (Array.isArray(params[key]) && params[key].length === 0)) {
            delete params[key]
          }
        })

        const response = await axios.get('/api/certifications/export/preview', { params })
        this.data = {
          certified_entities: response.data.certified_entities || [],
          certifications: response.data.certifications || [],
          standards: response.data.standards || [],
          sectors: response.data.sectors || [],
          sites: response.data.sites || []
        }
        this.summary = response.data.summary || { total_entities: 0, total_certifications: 0 }
        this.loaded = true
      } catch (error) {
        console.error('Error loading preview:', error)
        if (error.response && error.response.status === 401) {
          this.$router.push({ path: '/login' })
        }
      } finally {
        this.loading = false
      }
    },
    clearFilters() {
      this.filters = {
        date_from: '',
        date_to: '',
        expiry_date_from: '',
        expiry_date_to: '',
        update_date_from: '',
        update_date_to: '',
        status_id: '',
        client_id: ''
      }
      this.selectedServices = []
    },
    exportToExcel() {
      if (!this.hasData) return

      // Create workbook
      const wb = XLSX.utils.book_new()

      // Sheet 1: Certified Entity
      const entityHeaders = [
        'Certified Entity Unique ID', 'Certified Entity Name', 'Certified Entity Trading Name',
        'Certified Entity English Name', 'Confidential Certified Entity', 'Business Registered Street',
        'Business Registered City', 'Business Registered State', 'Business Registered Zipcode/Postcode',
        'Business Registered Country/Economy', 'Business Registered Full Address', 'Certified Entity Website',
        'TAX ID', 'VAT', 'Company ID Number', 'Business Registration Number', 'DUNS Number'
      ]
      const entityData = this.data.certified_entities.map(row => [
        row.certified_entity_unique_id, row.certified_entity_name, row.certified_entity_trading_name,
        row.certified_entity_english_name, row.confidential_certified_entity, row.business_registered_street,
        row.business_registered_city, row.business_registered_state, row.business_registered_zipcode,
        row.business_registered_country, row.business_registered_full_address, row.certified_entity_website,
        row.tax_id, row.vat, row.company_id_number, row.business_registration_number, row.duns_number
      ])
      const ws1 = XLSX.utils.aoa_to_sheet([entityHeaders, ...entityData])
      XLSX.utils.book_append_sheet(wb, ws1, 'Certified Entity')

      // Sheet 2: Certification
      const certHeaders = [
        'Certification Identity Number', 'Certificate Number', 'Certification Status', 'Certification Type',
        'Certification Scope', 'Flexible Scope', 'Certification Original Issue Date', 'Certification Issue Date',
        'Certification Expiry Date', 'Certified Entity Unique ID', 'Main Site Street', 'Main Site City',
        'Main Site State', 'Main Site Zipcode/Postcode', 'Main Site Country/Economy', 'Main Site Full Address',
        'Accreditation Body Name', 'Accreditation Body Acronym'
      ]
      const certData = this.data.certifications.map(row => [
        row.certification_identity_number, row.certificate_number, row.certification_status, row.certification_type,
        row.certification_scope, row.flexible_scope, row.certification_original_issue_date, row.certification_issue_date,
        row.certification_expiry_date, row.certified_entity_unique_id, row.main_site_street, row.main_site_city,
        row.main_site_state, row.main_site_zipcode, row.main_site_country, row.main_site_full_address,
        row.accreditation_body_name, row.accreditation_body_acronym
      ])
      const ws2 = XLSX.utils.aoa_to_sheet([certHeaders, ...certData])
      XLSX.utils.book_append_sheet(wb, ws2, 'Certification')

      // Sheet 3: Certification Standard & Scheme
      const standardHeaders = ['Certification Identity Number', 'Scheme Name', 'Standard Name']
      const standardData = this.data.standards.map(row => [
        row.certification_identity_number, row.scheme_name, row.standard_name
      ])
      const ws3 = XLSX.utils.aoa_to_sheet([standardHeaders, ...standardData])
      XLSX.utils.book_append_sheet(wb, ws3, 'Certification Standard & Scheme')

      // Sheet 4: Certification Sector
      const sectorHeaders = ['Certification Identity Number', 'Sector Name', 'Sector Code']
      const sectorData = this.data.sectors.map(row => [
        row.certification_identity_number, row.sector_name, row.sector_code
      ])
      const ws4 = XLSX.utils.aoa_to_sheet([sectorHeaders, ...sectorData])
      XLSX.utils.book_append_sheet(wb, ws4, 'Certification Sector')

      // Sheet 5: Certification Sites
      const siteHeaders = [
        'Certification Identity Number', 'Certified Entity Unique ID', 'Site Type', 'Site Street',
        'Site City', 'Site State', 'Site Zipcode/Postcode', 'Site Country/Economy', 'Site Full Address', 'Site Scope'
      ]
      const siteData = this.data.sites.map(row => [
        row.certification_identity_number, row.certified_entity_unique_id, row.site_type, row.site_street,
        row.site_city, row.site_state, row.site_zipcode, row.site_country, row.site_full_address, row.site_scope
      ])
      const ws5 = XLSX.utils.aoa_to_sheet([siteHeaders, ...siteData])
      XLSX.utils.book_append_sheet(wb, ws5, 'Certification Sites')

      // Generate filename with date
      const today = new Date().toISOString().slice(0, 10)
      const filename = `certifications_export_${today}.xlsx`

      // Download - browser compatible approach
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      // Convert binary string to ArrayBuffer
      function s2ab(s) {
        const buf = new ArrayBuffer(s.length)
        const view = new Uint8Array(buf)
        for (let i = 0; i < s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xFF
        }
        return buf
      }

      // Create blob and trigger download
      const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.loadFilterOptions()
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mt-3 {
  margin-top: 1rem;
}
.mb-4 {
  margin-bottom: 1.5rem;
}
</style>
